// @flow

import React, {useState} from 'react';

import { Tooltip, Fab, Hidden } from '@material-ui/core';
import { Theme, withTheme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/styles';
import { withTranslation } from 'react-i18next';

import SelectAccuracyDialog from './SelectAccuracyDialog';
import AccuracyIcon from '../../../assets/icons/accuracy.svg';

type Props = {
  theme: Theme,
  t: Function,
  status: Object,
  user: Object,
}

const useStyles = makeStyles({
  fab: {
    backgroundColor: 'white',
    textTransform: 'none',
    fontSize: 18,
    color: '#102867',
    fontWeight: 600,
    height: 44,
  },
  buttonText: {
    marginLeft: 10,
  }
})

function SelectAccuracyButton(props: Props) {
  const {t, theme, status, user} = props;
  const classes = useStyles(theme);
  const [dialogOpen, setDialogOpen] = useState(false);
  return (
    <>
      <SelectAccuracyDialog
        open={dialogOpen}
        setDialogOpen={setDialogOpen}
        status={status}
        user={user}
      />
      <Tooltip
        title={t('accuracy.improveAccuracy')}
        aria-label="change-accuracy"
        enterDelay={300}
        leaveDelay={200}
      >
        <Fab variant="extended" className={classes.fab} onClick={() => setDialogOpen(true)}>
          <img src={AccuracyIcon} alt="accuracy" />
          <Hidden only={['xs', 'sm']}>
            <span className={classes.buttonText}>
              {t('accuracy.improveAccuracy')}
            </span>
          </Hidden>
        </Fab>
      </Tooltip>
    </>
  );
}


export default withTheme(withTranslation()(SelectAccuracyButton));

